<template>
  <div
    v-show="results?.length > 0"
    class="predictive-search-bar__results-section"
  >
    <div
      class="predictive-search-bar__results-header"
      :class="{
        'not-products': !isProducts
      }"
      v-html="headerString()"
    />

    <ul
      :class="{
        'predictive-search-bar__card-grid products': isProducts
      }"
    >
      <li
        v-for="result of results.slice(0, 4)"
        :id="result.id"
        :key="result.id"
        :class="{
          'predictive-search-bar__results-product-wrapper': isProducts,
          'predictive-search-bar__results-wrapper': !isProducts
        }"
      >
        <a
          v-if="!isProducts"
          class="predictive-search-bar__result"
          :href="resultPage(result.handle)"
        >
          <span
            v-html="highlightQueryMatch(result.title)"
          />
        </a>

        <product-card
          v-else
          :product="result"
          block-class="predictive-search-bar"
          @click="handleAnalyticsEvent(product.id.toString(), $event)"
        />
      </li>
    </ul>

    <div
      v-if="isProducts && results.length > 1"
      class="predictive-search-bar__results-button-wrapper"
    >
      <btn
        class="predictive-search-bar__results-button"
        modifiers="light center"
        :show-icon="false"
        :label="$string(
          'search.view_all',
          {
            replace: {
              num: $parent.totalProducts
            }
          }
        )"
        :url="$parent.searchResultsPage"
      />
    </div>
  </div>

  <boost-analytics
    v-if="isProducts"
    :analytics-event="analyticsEvent"
    type="search"
  />
</template>

<script>

/**
 * Vue: Predictive search results section (predictive-search-results-section)
 * -----------------------------------------------------------------------------
 * For each section of the predictive search bar's query results,
 * i.e. collections or products.
 * @param {String} resultType
 */
import ProductCard from '~async/product-card/product-card'
import BoostAnalytics from '~global/boost-analytics/boost-analytics'
import Btn from '~global/btn/btn'

export default {
  name: 'PredictiveSearchResultsSection',

  components: {
    BoostAnalytics,
    Btn,
    ProductCard,
  },

  props: {
    resultType: {
      type: String,
      default: '',
    },
  },

  data() {
    return {
      analyticsEvent: {},
      global: true,
    }
  },

  computed: {

    /**
     * Boolean for whether or not the result type is products.
     */
    isProducts() {
      return this.resultType === 'products'
    },

    /**
     * Returns array of results in this section.
     */
    results() {
      return this.$parent[this.resultType]
    },
  },

  methods: {

    /**
     * Get string for results section header.
     * @returns {String}
     */
    headerString() {
      if (this.isProducts) {
        return this.formatTranslation(this.$string('search.products'))
      }

      return this.resultType
    },

    /**
     * Format translation by replacing placeholder with query value.
     * @param {String} translation
     * @returns {String}
     */
    formatTranslation(translation) {
      return `${translation.replace('{{ query }}', this.$parent.query)}`
    },

    /**
     * Pass data from analytics events to analytics component.
     * @param {String} productId - Product ID to string.
     * @param {Event} event - Click event.
     */
    handleAnalyticsEvent(productId, event) {
      if (event.target.classList.contains('product-card__swatch-image')) {
        return
      }

      this.analyticsEvent = {
        pid: productId,
        u: 'view_product',
      }
    },

    /**
     * Remove any existing bold tags, then wrap each query match in a bold tag.
     * @param {String} string
     * @returns {String}
     */
    highlightQueryMatch(string) {
      return string.replace(new RegExp(this.$parent.query, 'gi'), (match) => `<b>${match}</b>`)
    },

    /**
     * Returns address for a single result,
     * such as a collection or product page
     */
    resultPage(handle) {
      return `/${this.resultType}/${handle}`
    },
  },
}
</script>
